import { ReactNode } from 'react';
import { UnstyledButton } from '@mantine/core';
import { useFloatingMenuContext } from './store';
import classes from './FloatingMenuItem.module.css';

interface FloatingMenuItemProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  itemIndex: number;
}

export function FloatingMenuItem({ children, itemIndex, ...props }: FloatingMenuItemProps) {
  const { activeIndex, getItemProps, listRef } = useFloatingMenuContext();

  return (
    <UnstyledButton
      className={classes.FloatingMenuItem}
      data-hovered={activeIndex === itemIndex ? true : undefined}
      aria-selected={activeIndex === itemIndex ? true : undefined}
      {...getItemProps({
        ...props,
        active: activeIndex === itemIndex,
        role: 'option',
        id: `floating-menu-item-${itemIndex}`,
        ref: (node: HTMLButtonElement) => {
          listRef.current[itemIndex] = node;
        },
      })}
    >
      {children}
    </UnstyledButton>
  );
}
